export default {
  '审图资料上传': 'Upload Map Review Data',
  '需要上传': 'Need to upload ',
  '可选上传': 'Optional upload ',
  '张': 'copies',
  '已上传': 'Uploaded',
  '每张最大不超过10M': 'Maximum not exceeding 10M per sheet',
  '查看': 'See',
  '报图样板': 'Presentation pattern',
  '审核通过即不能进行修改': 'No modification is allowed once the audit is approved.',
  '审核意见': 'Audit Opinions',
  '示例图片': 'Example picture',
  '上传': 'Upload',
  '上一步': 'Previous',
  '保存': 'Save',
  '确认提交': 'Submit',
  '图片上传数量不足': 'Insufficient number of photos uploaded',
  '图片上传失败': 'Picture upload failed',
  '该展位下已存在有效的审图状态': 'Effective drawing review status already exists under this booth.',
  '的图片总大小不能大于10M': ' The total size of the picture should not be greater than 10M',
  '要求': 'Claim',
  '如需对图片进行说明，请点击': 'For description of the picture, please click here',
  '添加备注': ' to add notes',
  '请添加备注': 'Please add a note',
  '关闭': 'close up',
  '审核未通过': 'Audit failed',
  '审核通过': 'Approved',
  '待审核': 'Pending',
  '审核不通过的审图': 'Failed review of drawings',
  '展开提交审图图纸': 'Unfold and submit drawings for review',
  '暂无示例图片': 'No sample image',
  "以下图纸将不会提交审核": "The following drawings will not be submitted for review",
  '选填': 'Optional',
}



// WEBPACK FOOTER //
// ./src/i18n/en-us/drawings/drawingsUpload.js